import { StepAnswer } from '@models/quiz';

export interface QuizAnalyticsContext {
  quiz_name: string
  quiz_category: string
  quiz_id: string
}

export interface QuizQuestionAnalytics {
  label: string
  id: string
  slug: string
  answers: string[]
}

const formatAnswerValues = (answer?: StepAnswer<any>): string[] => {
  if (!answer?.value) {
    return [];
  }

  const { value } = answer;

  if (Array.isArray(value)) {
    return value.map(String);
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.map(String);
      }
    } catch {
      // Not JSON — use raw string value.
    }

    return value ? [value] : [];
  }

  return [String(value)];
};

export const buildQuizQuestionsPayload = (
  stepAnswers: StepAnswer<any>[],
  answeredValues: StepAnswer<any>[] = [],
): QuizQuestionAnalytics[] => {
  const valuesById = new Map(
    answeredValues.map((answer) => [answer.id, answer]),
  );

  return stepAnswers.map((answer) => {
    const answered = valuesById.get(answer.id) ?? answer;

    return {
      label: answer.title,
      id: String(answer.id),
      slug: answer.slug,
      answers: formatAnswerValues(answered),
    };
  });
};

export const getQuizStartedStorageKey = (quizId: string | number) => `quiz_started_${quizId}`;

export const getQuizCompletedStorageKey = (quizId: string | number) => `quiz_completed_${quizId}`;
